/**
 * LEGACY LIFETIME LICENCES — what the dashboard needs to know about them.
 *
 * A Chrome-extension lifetime licence holder who signs up here is granted
 * `pro_lifetime` (see cloud/backend/src/services/legacyLicense/). It behaves
 * like any other paid plan except that nobody is billing for it: no interval,
 * no renewal date, and — until they buy credits — no Stripe customer at all.
 *
 * The plan is deliberately absent from every catalogue, so it never appears in
 * a pricing grid; what needs saying is only ever about the plan they are
 * already on. Three places ask:
 *
 *   AccountView         → the plan line ("Custom plan" is not what this is)
 *   CurrentPlanBanner   → the price line (there is no price to print)
 *   PlansViewV2         → the CTA (they can still buy a subscription)
 *
 * Delete this file and its three importers to retire the feature.
 */

/** Matches LIFETIME_PLAN_NAME in cloud/backend/src/config/plans.js. */
export const LIFETIME_PLAN = 'pro_lifetime';

export const isLifetimePlan = (planName) => planName === LIFETIME_PLAN;

/**
 * Is there a live Stripe subscription behind this plan?
 *
 * The question that decides whether "Switch Plan → billing portal" is the right
 * CTA or a dead end. A lifetime holder is on a paid plan and has no
 * subscription, which is a combination nothing else in the catalogue produces —
 * so `plan !== 'free'` stopped being a safe proxy for it the day this shipped.
 */
export const hasStripeSubscription = (billingStatus) => {
  const planName = billingStatus?.subscription?.plan?.name;
  if (!planName || planName === 'free' || isLifetimePlan(planName)) return false;
  return Boolean(billingStatus?.subscription?.plan_stripe?.subscription_id);
};
